import { Component, Input, OnChanges } from '@angular/core';
import { ColumnSetting, ColumnMap } from '@app/models/common/columnSetting';
@Component({
    selector: 'tabular-list',
    templateUrl: './tabular-list.component.html'
})
export class TabularListComponent implements OnChanges { 
    @Input() records: any[];
    @Input() caption: string;
    @Input() settings: ColumnSetting[];
    columnMaps: ColumnMap[]; 
    ngOnChanges() {
        if (this.settings) {
            this.columnMaps = this.settings
                .map( col => new ColumnMap(col) );
        } else {
            this.columnMaps = Object.keys(this.records[0])
                .map( key => {
                    return new ColumnMap( { primaryKey: key });
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/common/tabular-list/tabular-list.component.ts